import CustomFieldInput from './CustomFieldInput.vue';
import CustomFieldRadio from './CustomFieldRadio.vue';
import CustomFieldCheckbox from './CustomFieldCheckbox.vue';
import CustomFieldImage from './CustomFieldImage.vue';
import CustomFieldFile from './CustomFieldFile.vue';

// 字段类型常量
export const FIELD_TYPE = {
	INPUT: 0, // 输入框
	RADIO: 1, // 单选框
	CHECKBOX: 2, // 多选框
	IMAGE: 3, // 图片
	FILE: 5 // 文件
};

// 组件映射
const componentMap = {
	[FIELD_TYPE.INPUT]: CustomFieldInput,
	[FIELD_TYPE.RADIO]: CustomFieldRadio,
	[FIELD_TYPE.CHECKBOX]: CustomFieldCheckbox,
	[FIELD_TYPE.IMAGE]: CustomFieldImage,
	[FIELD_TYPE.FILE]: CustomFieldFile
};

/**
 * 根据 fieldType 获取对应的组件
 * @param {number} fieldType - 字段类型
 * @returns {Object|null} Vue 组件
 */
export const getCustomFieldComponent = fieldType => {
	return componentMap[fieldType] || componentMap[FIELD_TYPE.INPUT]; // 默认返回输入框
};

export default {
	FIELD_TYPE,
	getCustomFieldComponent,
	CustomFieldInput,
	CustomFieldRadio,
	CustomFieldCheckbox,
	CustomFieldImage,
	CustomFieldFile
};
